import { createActionGroup, props } from '@ngrx/store';

export const SetGamesView = createActionGroup({
  source: 'SetGamesView',
  events: {
    '[SetGamesView] Set Games View': props<{
      data: boolean;
    }>(),
  },
});
